import { Text }             from "components/styled"
import {
    commonLocalization,
    currency,
    number,
    projectsLocalization,
}                           from "localization"
import React, { Component } from "react"
import { connect }          from "react-redux"
import {
    Link,
    withRouter,
}                           from "react-router-dom"
import ScrollArea           from "react-scrollbar"
import styled               from "styled-components"
import Icon                 from "components/Icon/Icon"

class ProjectTable extends Component {
    state = {
        sortState: {
            title: "",
            cost_estimation: "",
            agreement_amount: "",
            status: "",
        }
    }

    getWards = wards => (
        <ul className="ward-num">
            {wards && wards.map((val, index) => <li key={index}>{number(val)}</li>)}
        </ul>
    )

    goToDetail = projectId => {
        this.props.history.push(`/projects/${projectId}`)
    }

    sortByType(type) {
        if (this.state.sortState[type] === "" || this.state.sortState[type] === "desc") {
            // sort data in ascending order
            const newSortState = Object.keys(this.state.sortState).reduce((acc, currKey) => {
                acc[currKey] = currKey === type ? 'asc' : '';
                return acc;
            }, {});

            this.setState({ sortState: newSortState }, () =>
                this.props.sortByType(type, this.state[type]),
            )
        } else {
            // sort in descending
            const newSortState = Object.keys(this.state.sortState).reduce((acc, currKey) => {
                acc[currKey] = currKey === type ? 'desc' : '';
                return acc;
            }, {});

            this.setState({ sortState: newSortState }, () =>
                this.props.sortByType(type, this.state[type]),
            )
        }
    }

    render() {
        const { projects, selectedLanguage, fetching } = this.props

        const {
            projectTable: {
                title: projectTableWideTitle,
                estimatedBudget: estimateBudgetLabel,
                contractBudget: contractBudgetLabel,
                wards: wardsLabel,
                contractingParty: contractingPartyLabel,
                status: statusLabel,
                department: departmentLabel,
            },
        } = projectsLocalization[selectedLanguage]

        const localizationCommon = commonLocalization[selectedLanguage]
        const localizationProject = projectsLocalization[selectedLanguage]

        const { title, cost_estimation, status, agreement_amount } = this.state.sortState

        return (
            <TableWrapper
                className="table-wrap"
                lang={selectedLanguage}
                projectTableWideTitle={projectTableWideTitle}
                estimateBudgetLabel={estimateBudgetLabel}
                contractBudgetLabel={contractBudgetLabel}
                contractingPartyLabel={contractingPartyLabel}
                wardsLabel={wardsLabel}
                statusLabel={statusLabel}
            >
                <table>
                    <thead>
                        <tr>
                            <th
                                onClick={() => this.sortByType("title")}
                                width="30%"
                                className={title === "asc" ? "asc" : "desc"}
                            >
                                <div className="flex items-center gap-1">
                                    <div className="sorting-icon">
                                        <Icon name={'arrow-up'} active={title === 'asc'} />
                                        <Icon name={'arrow-down'} active={title === 'desc'} />
                                    </div>
                                    {projectTableWideTitle}
                                </div>
                            </th>
                            <th width="15%">{departmentLabel}</th>
                            <th
                                onClick={() => this.sortByType("cost_estimation")}
                                width="15%"
                                className={cost_estimation === "asc" ? "asc" : "desc"}
                            >
                                <div className="flex items-center gap-1">
                                    <div className="sorting-icon">
                                        <Icon name={'arrow-up'} active={cost_estimation === 'asc'} />
                                        <Icon name={'arrow-down'} active={cost_estimation === 'desc'} />
                                    </div>
                                    {estimateBudgetLabel}
                                </div>
                            </th>
                            <th
                                onClick={() => this.sortByType("agreement_amount")}
                                width="15%"
                                className={agreement_amount === "asc" ? "asc" : "desc"}
                            >
                                <div className="flex items-center gap-1">
                                    <div className="sorting-icon">
                                        <Icon name={'arrow-up'} active={agreement_amount === 'asc'} />
                                        <Icon name={'arrow-down'} active={agreement_amount === 'desc'} />
                                    </div>
                                    {contractBudgetLabel}
                                </div>
                            </th>
                            <th width="15%">{contractingPartyLabel}</th>
                            <th width="12%">{wardsLabel}</th>
                            <th
                                onClick={() => this.sortByType("status")}
                                width="130px"
                                className={status === "asc" ? "asc" : "desc"}
                            >
                                <div className="flex items-center gap-1">
                                    <div className="sorting-icon">
                                        <Icon name={'arrow-up'} active={status === 'asc'} />
                                        <Icon name={'arrow-down'} active={status === 'desc'} />
                                    </div>
                                    {statusLabel}
                                </div>
                            </th>
                        </tr>
                    </thead>
                </table>
                <ScrollArea
                    className="options"
                    style={{ marginTop: 0 }}
                    smoothScrolling={true}
                    minScrollSize={30}
                >
                    <table>
                        <tbody>
                            {projects.length > 0 &&
                            !fetching &&
                            projects.map((project, index) => (
                                <tr key={index} onClick={() => this.goToDetail(project.id)}>
                                    <td width="30%">
                                        <Link to={`/projects/${project.id}`}>
                                            {selectedLanguage === "np"
                                                ? project.title
                                                : project.title_en || project.title}
                                        </Link>
                                    </td>
                                    <td width="15%">{project.department ? project.department[selectedLanguage === "np" ? "title_ne" : "title_en"] : ""}</td>


                                    <td width="15%">
                                        {`${currency(
                                            project.cost_estimate_without_vat.toFixed(0),
                                        )}`}
                                    </td>
                                    <td width="15%">
                                        {`${currency(
                                            project.agreement_amount_without_vat.toFixed(0),
                                        )}`}
                                    </td>
                                  




                                    <td width="15%">{project.name_of_contractor}</td>
                                    <td width="12%">
                                        <ul>{this.getWards(project.wards)}</ul>
                                    </td>
                                    <td width="130px">
                                        <Text.span
                                            uppercase
                                            lighter
                                            className={
                                                project.status.name === "implementation"
                                                    ? "status status--running"
                                                    : project.status.name === "completion"
                                                    ? "status status--completed"
                                                    : project.status.name === "pipeline"
                                                        ? "status status--tendered"
                                                        : "status status--not-started"
                                            }
                                        >
                                            {localizationCommon[project.status.name]}
                                        </Text.span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </ScrollArea>
            </TableWrapper>
        )
    }
}

const TableWrapper = styled.div`
  table tr th {
    font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
    padding-bottom: 6px;
    &.asc,
    &.desc {
      background-position: ${props =>
    props.lang === "en" ? "-4px 15px" : "-4px 17px"};
    }
  }
  table tr td {
    font-size: ${props => (props.lang === "en" ? "14px" : "15px")};
    text-transform: capitalize;
    .status {
      font-size: ${props => (props.lang === "en" ? "12px" : "13px")};
      padding: ${props => (props.lang === "en" ? "4px 10px" : "2px 10px")};
      &:empty {
        display: none;
      }
    }
  }

  @media only screen and (max-width: 1024px) {
    td {
      min-height: 51px;
      &:before {
        font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
      }
    }

    td:nth-of-type(1):before {
      content: ${props => "'" + props.projectTableWideTitle + "'"};
    }
    td:nth-of-type(2):before {
      content: ${props => "'" + props.estimateBudgetLabel + "'"};
    }
    td:nth-of-type(3):before {
      content: ${props => "'" + props.contractBudgetLabel + "'"};
    }
    td:nth-of-type(4):before {
      content: ${props => "'" + props.contractingPartyLabel + "'"};
    }
    td:nth-of-type(5):before {
      content: ${props => "'" + props.wardsLabel + "'"};
    }
    td:nth-of-type(6):before {
      content: ${props => "'" + props.statusLabel + "'"};
    }
  }
`

const mapStateToProps = state => ({
    selectedLanguage: state.localizationReducers.selectedLanguage,
    fetching: state.infraMonitor.fetching,
})

export default withRouter(connect(mapStateToProps)(ProjectTable))



// WEBPACK FOOTER //
// ./src/pages/project/list/partials/project-table.js